import React from 'react';
import './InnerFooter.css';

/**
 * InnerFooter — shared bottom footer for all inner (authenticated) pages.
 */
const InnerFooter = () => {
    return (
        <div className="inner-footer-wrap">
            <p>© 2026 Accel1 Inc. All rights reserved &nbsp;&nbsp;|&nbsp;&nbsp; www.accel1.com</p>
        </div>
    );
};

export default InnerFooter;
